const STATE_KEY = 'appState';

export const loadState = () => {
  try {
    const serializedState = window.localStorage.getItem(STATE_KEY);
    if (!serializedState) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    window.localStorage.setItem(STATE_KEY, serializedState);
  } catch (err) {
    // Ignore errors
  }
};



// WEBPACK FOOTER //
// ./src/store/localStorage.js